<template>
  <div class="">
    <check-box-manager class="my-2" :CheckBoxItems="categories" label="انتخاب دسته بندی"
                       :selectedCheckBoxes="selectedCategory" :validation="$v.selectedCategory"/>
  </div>
</template>

<script>
import CheckBoxManager from "../../../Content/FormItems/CheckBoxManager.vue";

export default {
  name: "Category",
  components: {CheckBoxManager},
  data() {
    return {
      categories: [],
      selectedCategory: []
    }
  },
  validations: {
    selectedCategory: {},
  },
  async mounted() {
    let value = this.$route.query.category;
    if (value != undefined) {
      value = value.split(',')
      console.log(value)
      this.$store.commit('Product/setFilters', {key: 'category', value: value})
    }


    this.categories = await this.$store.dispatch('Category/getDashboardCategoriesWithoutState')
    this.categories = this.categories.data.data
  },
  watch: {
    selectedCategory: {
      handler(oldValue, newValue) {
        let page = 1
        this.$store.commit("Product/setFilters", {key: "category", value: this.selectedCategory.map(item => item.id)});
        this.$emit('updateFilter', {category: this.selectedCategory})
        this.$store.dispatch("Product/setDashboardProducts", page);
      }
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "category", value: []});
  }
}
</script>

<style scoped>
.category-filter {
  height: 150px;
  overflow-y: auto;
  background: #f3f3f3;
}
</style>